import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { CarbonCommissionTaskPayload } from '../models/task-payload';

export const CarbonCommissionTaskEditActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[carbon/commission-task] Edit'),
  requestFail: uniqueActionType('[carbon/commission-task] Edit fail'),
  requestSuccess: uniqueActionType('[carbon/commission-task] Edit success'),
  requestClearErrors: uniqueActionType('[carbon/commission-task] Edit clear errors'),
  requestClear: uniqueActionType('[carbon/commission-task] Edit clear')
};

export class CarbonCommissionTaskEditAction implements PayloadAction {
  readonly type = CarbonCommissionTaskEditActionTypes.request;

  constructor(public payload: SendByIdPayload<CarbonCommissionTaskPayload>) {
  }
}

export class CarbonCommissionTaskEditFailAction implements PayloadAction {
  readonly type = CarbonCommissionTaskEditActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class CarbonCommissionTaskEditSuccessAction implements PayloadAction {
  readonly type = CarbonCommissionTaskEditActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class CarbonCommissionTaskEditClearErrorsAction implements PayloadAction {
  readonly type = CarbonCommissionTaskEditActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class CarbonCommissionTaskEditClearAction implements PayloadAction {
  readonly type = CarbonCommissionTaskEditActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
